import React, { FC, ReactNode } from 'react'
import cx from 'classnames'
import styles from './button.module.scss'
import { amClickedButton } from 'events/amplitude'

export interface ButtonProps {
	size?: 'large' | 'medium' | 'small'
	onClick?: () => void
	id: string
	ariaLabel?: string
	className?: string
	type?: 'button' | 'submit' | 'reset'
	children?: ReactNode
}

export const Button: FC<ButtonProps> = (props) => {
	const style = props.size == 'large' ? styles.button_large : props.size == 'medium' ? styles.button_medium : props.size == 'small' ? styles.button_small : ''

	const handleOnClick = () => {
		amClickedButton('[children]', props.id)

		if (props.onClick) {
			props.onClick()
		}
	}

	const buttonClass = style ? cx(styles.button, style, props.className) : cx(styles.button_unstyled, props.className)

	return (
		<button
			className={buttonClass}
			id={props.id}
			onClick={handleOnClick}
			aria-label={props.ariaLabel}
			type={'submit'}
		>
			{props.children}
		</button>
	)
}
